import { Divider, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/material";
import { BackButton } from "./BackButton";

type Props = {
  pageName: React.ReactNode;
  isBackBtn?: boolean;
  isEdit?: boolean;
};

const ButtonArea: FC<Props> = ({ children, pageName, isBackBtn = false }) => {
  const PageName = useMemo(() => {
    return (
      <Typography variant="h2" fontSize={"1.25rem"} noWrap>
        {pageName}
      </Typography>
    );
  }, [pageName]);

  return (
    <Box>
      <Stack
        direction="row"
        sx={{ p: 2 }}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Stack direction="row" spacing={2} alignItems={"center"}>
          {isBackBtn && <BackButton />}
          {PageName}
        </Stack>

        <Stack direction="row" spacing={2}>
          {children}
        </Stack>
      </Stack>
      <Divider />
    </Box>
  );
};

export default ButtonArea;
